import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { navItems, assets } from "../mock";

const Navbar = ({ visible, onReset }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  if (!visible) return null;

  return (
    <>
      <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
        <a
          href="#top"
          className="nav-brand"
          aria-label="Return to ODDA Corp. landing"
          onClick={(e) => {
            if (onReset) {
              e.preventDefault();
              onReset();
            }
          }}
        >
          <img src={assets.logoWhite} alt="ODDA Corp." className="nav-brand__logo" />
        </a>
        <nav className="nav-links">
          {navItems.map((n) => (
            <a key={n.href} href={n.href}>
              {n.label}
            </a>
          ))}
        </nav>
        <button className="nav-toggle" onClick={() => setOpen(true)} aria-label="Open menu">
          <span>Menu</span>
          <Menu size={16} />
        </button>
      </header>

      <div className={`menu-panel ${open ? "menu-panel--open" : ""}`}>
        <div className="menu-panel__top">
          <img src={assets.logoWhite} alt="ODDA Corp." className="menu-panel__logo" />
          <button className="menu-close" onClick={() => setOpen(false)} aria-label="Close menu">
            <X size={20} />
          </button>
        </div>
        <div className="menu-panel__grid">
          <div className="menu-panel__nav">
            {navItems.map((n, i) => (
              <a key={n.href} href={n.href} onClick={() => setOpen(false)}>
                <span className="menu-panel__num">0{i + 1}</span>
                <span className="menu-panel__text">{n.label}</span>
              </a>
            ))}
          </div>
          <div className="menu-panel__meta">
            <div>
              <span className="kicker">Studio</span>
              <p>Toronto · Canada</p>
              <p>hello@oddastudio.com</p>
            </div>
            <div>
              <span className="kicker">Discipline</span>
              <p>Architecture</p>
              <p>Design</p>
              <p>Development</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
